export function detectExternalSource(url) {
  if (!url) return null
  const trimmed = url.trim().toLowerCase()
  if (!trimmed) return null
  if (trimmed.includes('youtube.com') || trimmed.includes('youtu.be')) return 'YouTube'
  if (trimmed.includes('instagram.com')) return 'Instagram'
  if (trimmed.includes('tiktok.com')) return 'TikTok'
  if (trimmed.includes('drive.google.com')) return 'Google Drive'
  if (trimmed.includes('twitter.com') || trimmed.includes('x.com')) return 'X (Twitter)'
  return null
}
